import { UnderwritingStatus } from '../shared/interfaces';

export enum InspectionStatus {
  INVALID_STATE,
  NO_DATE_ASSIGNED,
  READY_TO_BE_ASSIGNED,
  ASSIGNMENT_MADE,
  NEEDS_REVIEW,
  WAITING,
  REJECTED,
  ACCEPTED,
  DEPRECATED_COMPLETED,
  INVALID_SYNC,
}

export const statusAsText = (status: InspectionStatus) => {
  switch (status) {
    case InspectionStatus.NO_DATE_ASSIGNED:
      return 'No date assigned';
    case InspectionStatus.READY_TO_BE_ASSIGNED:
      return 'Ready to be assigned';
    case InspectionStatus.ASSIGNMENT_MADE:
      return 'Assignment made';
    case InspectionStatus.NEEDS_REVIEW:
      return 'Needs review';
    case InspectionStatus.WAITING:
      return 'Waiting';
    case InspectionStatus.REJECTED:
      return 'Rejected';
    case InspectionStatus.ACCEPTED:
      return 'Accepted';
    case InspectionStatus.DEPRECATED_COMPLETED:
      return 'Completed';
    case InspectionStatus.INVALID_SYNC:
      return 'Invalid Sync';
  }
  return 'Invalid State';
};

export const underwritingStatusAsText = (status: UnderwritingStatus) => {
  switch (status) {
    case UnderwritingStatus.PREPARE_FLAGS:
      return 'Prepare Flags';
    case UnderwritingStatus.PREPARATION_IN_PROGRESS:
      return 'Preparation In Progress';
    case UnderwritingStatus.LETTER_SENT:
      return 'Letter Sent';
    case UnderwritingStatus.RESOLUTION_IN_PROGRESS:
      return 'Resolution In Progress';
    case UnderwritingStatus.CLOSED:
      return 'Closed';
  }
  return 'Invalid State';
};
